import React from 'react';
import Faq from '../../components/controls/Faq';


const faqData = [
  {
    category: 'Algemene vragen',
    questions: [
      {
        question: '1. Wat is infraplannen.nl?',
        answer: `<p>
                  Infraplannen.nl is ontwikkeld in opdracht van netbeheerders die deelnemen aan Stichting Mijn Aansluiting. 
                  Het platform biedt organisaties de mogelijkheid om op uniforme wijze langetermijnplannen met andere organisaties te delen, met data vanuit de eigen bron. 
                  Dit inzicht in elkaars toekomstige werkpakketten in de ondergrond draagt bij aan een voorspelbare en continue werkstroom in de keten.
                </p>
                <p>
                  Naast inzicht in elkaars plannen, biedt infraplannen.nl de mogelijkheid voor organisaties om plannen op elkaar af te stemmen, wat publieke overlast beperkt en efficiëntie verhoogt.
                </p>`
      },
      {
        question: '2. Voor wie is infraplannen.nl?',
        answer: `<p>
                  Infraplannen.nl is ontwikkeld voor (semi)overheidsorganisaties die - onder andere - werkzaam zijn in de ondergrond, zoals netbeheerders, gemeenten, provincies en waterschappen. 
                  Uw organisatie kan gebruikmaken van infraplannen.nl wanneer er minimaal één netbeheerder (deelnemer van Stichting Mijn Aansluiting) in uw regio is aangesloten bij infraplannen.nl die heeft aangegeven plannen met uw organisatie te delen en vice versa. 
                  Bekijk welke netbeheerders bij infraplannen.nl zijn aangesloten en zorg dat u wordt uitgenodigd door één van de netbeheerders in uw regio.
                </p>`
      },
      {
        question: '3. Waarom infraplannen.nl?',
        answer: `<p>
                  Maatschappelijke transities zoals de energietransitie en klimaatadaptatie vragen veel van netbeheerders en overheden; integrale planafstemming hierbij is pure noodzaak.
                </p>
                <p>
                  Complicerende factor is dat organisaties werken in verschillende systemen, waarbij een netbeheerder binnen het verzorgingsgebied te maken kan hebben met meer dan honderd gemeenten en diverse waterschappen.
                </p>
                <p>
                  Met infraplannen.nl kan iedere organisatie in hun eigen systeem blijven werken. IT-koppelingen zorgen voor continue synchronisatie van data die organisaties delen vanuit de eigen bron.
                </p>`
      },
      {
        question: '4. Kan iedereen zich aanmelden voor infraplannen.nl?',
        answer: `<p>
                  Niet iedereen kan toegang krijgen. Infraplannen.nl is een online platform voor netbeheerders, aangesloten bij Stichting Mijn Aansluiting om plannen met andere stakeholders in de ondergrond onderling te delen en af te stemmen.
                </p>
                <p>
                  Wilt u als overheidsorganisatie of semioverheidsorganisatie toegang tot infraplannen.nl? 
                  Uw organisatie kan gebruikmaken van infraplannen.nl wanneer er minimaal één netbeheerder (deelnemer van Stichting Mijn Aansluiting) in uw regio is aangesloten bij infraplannen.nl die heeft aangegeven plannen met uw organisatie te delen en vice versa. 
                  Bekijk welke netbeheerders bij infraplannen.nl zijn aangesloten en zorg dat u wordt uitgenodigd door één van de netbeheerders in uw regio. 
                  Stichting Mijn Aansluiting neemt vervolgens contact met u op om uw organisatie te onboarden.
                </p>`
      },
    ],
  },
  {
    category: 'Vragen over toegang tot infraplannen.nl',
    questions: [
      {
        question: '1. Hoe krijgt mijn organisatie toegang tot infraplannen.nl?',
        answer: `<p>
                  Bent u werkzaam bij een (semi)overheidsorganisatie zoals een gemeente, provincie of waterschap? Dan kan een deelnemende netbeheerder in uw gebied u uitnodigen voor infraplannen.nl. 
                  Neem daarvoor contact op met een van uw netbeheerders. Hebt u geen contactgegevens van uw netbeheerders voor deze vraag? Dan kunt u contact opnemen met <a href="mailto:contact@infraplannen.nl">contact@infraplannen.nl</a>.
                </p>
                <p>
                  Voor netbeheerders geldt dat er met alle deelnemers van Stichting Mijn Aansluiting contact is over infraplannen.nl.
                </p>
                <p>
                  Het aantal deelnemers op infraplannen.nl groeit snel. Bekijk de organisaties die actief zijn op infraplannen.nl: <a href="https://status.infraplannen.nl" target="_blank" rel="noopener noreferrer">status.infraplannen.nl</a>.
                </p>`
      },
      {
        question: '2. Moet onze organisatie met de andere organisaties in de regio een samenwerkingsverband hebben voordat we toegang kunnen krijgen tot infraplannen.nl?',
        answer: `<p>
                  Een samenwerkingsverband is geen voorwaarde om toegang te krijgen tot infraplannen.nl. 
                  Echter is het sterk aan te raden om op zijn minst onderlinge afspraken te maken over het inzien van elkaars plannen en de afstemming over de plannen. 
                  Bekijk het actuele overzicht van samenwerkingsverbanden integrale planafstemming op deze kaart:
                  <a href="https://www.desamenwerkwijzer.nl" target="_blank" rel="noopener noreferrer">www.desamenwerkwijzer.nl</a>.
                </p>
                <p>
                  Adviezen en handige stappenplannen voor succesvol integraal afstemmen zijn te vinden op <a href="https://www.desamenwerkwijzer.nl" target="_blank" rel="noopener noreferrer">www.desamenwerkwijzer.nl</a>. 
                  Daarnaast kunnen adviseurs van Stichting Mijn Aansluiting ondersteunen bij het verkennen van de mogelijkheden. Neem contact op via <a href="mailto:contact@infraplannen.nl">contact@infraplannen.nl</a>.
                </p>`
      },
      {
        question: '3. Hoe word ik key-user van infraplannen.nl vanuit mijn organisatie?',
        answer: `<ol>
                  <li>
                    De netbeheerder(s) in uw regio geven opdracht om uw organisatie toegang te geven tot infraplannen.nl.
                  </li>
                  <li>
                    U realiseert de technische koppeling met uw systeem.
                  </li>
                  <li>
                    Uw organisatie bepaalt wie de key-user wordt en geeft dit door aan infraplannen.nl.
                  </li>
                </ol>`
      },
      {
        question: '4. Hoe zorg ik dat ons eigen plansysteem gekoppeld wordt aan infraplannen.nl?',
        answer: `<p>
                  Ga naar de <a href="https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/618463238/Technische+documentatie+infraplannen.nl" target="_blank" rel="noopener noreferrer">wiki-pagina</a> voor informatie over de connectiviteit van infraplannen.nl met het bronsysteem van uw organisatie.
                </p>`
      },
      {
        question: '5. Hoe geef ik mijn collega ook toegang tot infraplannen.nl?',
        answer: `<p>
                  De key-user van een organisatie kan collega's uitnodigen om deel te nemen aan infraplannen.nl.
                </p>`
      },
      {
        question: '6. Hoe zorg ik dat andere organisaties hun plannen ook delen op infraplannen.nl?',
        answer: `<p>
                  Het delen van plannen via infraplannen.nl is niet verplicht. Wel kunt u met andere partijen die werkzaam zijn in de ondergrond in uw regio, het gesprek voeren over het belang ervan.
                </p>
                <p>
                  Heeft u hierbij hulp nodig, bekijk dan de video's en artikelen op <a href="https://www.desamenwerkwijzer.nl" target="_blank">www.desamenwerkwijzer.nl</a> of neem contact op met onze adviseurs op het gebied van integrale planafstemming via <a href="mailto:contact@infraplannen.nl">contact@infraplannen.nl</a>.
                </p>`
      },
      {
        question: '7. Hoe werkt het inloggen op infraplannen.nl?',
        answer: `<p>
                  Nadat uw account is geactiveerd, verloopt het inloggen via EntraID; de geïntegreerde identiteits- en toegangsoplossing van Microsoft365.
                </p>`
      },
    ],
  },
  {
    category: 'Vragen over het delen van plannen',
    questions: [
      {
        question: '1. Hoe worden de plannen gedeeld op infraplannen.nl?',
        answer: `<p>
                  Ga naar de <a href="https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/618463238/Technische+documentatie+infraplannen.nl" target="_blank" rel="noopener noreferrer">wiki-pagina</a> voor informatie over het delen van plannen met infraplannen.nl . 
                </p>`
      },
      {
        question: '2. Welke data wordt per plan opgeslagen?',
        answer: `<p>
                  Plannen worden op infraplannen.nl op hoofdlijnen gedeeld. <a href="https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/628457483/Properties+infraplannen.nl" target="_blank">Bekijk de precieze informatie die per plan wordt opgeslagen</a>.
                </p>`
      },
      {
        question: '3. Waar wordt de data bewaard?',
        answer: `<p>
                  De data op infraplannen.nl wordt opgeslagen in datacenters in West-Europa in Microsoft Azure.
                </p>`
      },
      {
        question: '4. Kan ik mijn plannen gedeeltelijk delen met anderen?',
        answer: `<p>
                  Ja, het is mogelijk om enkel geselecteerde plannen met bepaalde organisaties te delen.
                </p>`
      },
      {
        question: '5. Zijn de plannen op infraplannen.nl allemaal up-to-date?',
        answer: `<p>
                  Bij een automatische koppeling met infraplannen.nl probeert het systeem de plannen elke dag te verversen. Bij een handmatige upload hangt dat af van de frequentie van uploaden. <a href="https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/628359205/Data+uitwisselen+met+infraplannen.nl" target="_blank">Meer informatie</a>.
                </p>`
      },
      {
        question: '6. Hoe kom ik in contact over de plannen van andere organisaties die ik zie in infraplannen.nl?',
        answer: `<p>
                  Bij elk plan kunnen één of meerdere contactpersonen met contactgegevens worden vermeld door de partij die de plannen deelt.
                </p>`
      },
      {
        question: '7. Hoe leg ik vast dat andere organisaties onze plannen niet verder delen?',
        answer: `<p>
                  In de Algemene Gebruiksvoorwaarden van infraplannen.nl zijn algemene afspraken rondom geheimhouding opgenomen. Eén van de afspraken is dat plannen niet verder gedeeld mogen worden zonder expliciete toestemming van de eigenaar.
                </p>
                <p>
                  Er vindt op dit moment onderzoek plaats naar welke contractuele afspraken tussen organisaties benodigd zijn bij het gebruik van infraplannen.nl. 
                  Tot die tijd is het aan te raden een geheimhoudingsovereenkomst af te sluiten met de organisatie(s) waarmee u plannen deelt. 
                  Via de samenwerkwijzer.nl is een template beschikbaar, waar gedeeltes van gebruikt kunnen worden als basis voor een eigen overeenkomst. 
                  U vindt het template tussen samenwerkende partijen in de bibliotheek van <a href="https://www.desamenwerkwijzer.nl" target="_blank">www.desamenwerkwijzer.nl</a>.
                </p>`
      },
    ],
  },
  {
    category: 'Vragen vanuit key-users',
    questions: [
      {
        question: '1. Hoe draag ik het zijn van key-user over aan een collega?',
        answer: `<p>
                  Neem hiervoor contact op met Mijn Aansluiting via de <a href="https://mijnaansluiting.atlassian.net/servicedesk/customer/portals" target="_blank">servicedesk</a>.
                </p>`
      },
      {
        question: '2. Kunnen er meerdere key-users zijn binnen één organisatie?',
        answer: `<p>
                  Ja, dat is mogelijk. Neem hiervoor contact op met Mijn Aansluiting via de <a href="https://mijnaansluiting.atlassian.net/servicedesk/customer/portals" target="_blank">servicedesk</a>.
                </p>`
      },
      {
        question: '3. Hoe voeg ik gebruikers toe?',
        answer: `<p>
                  Een key-user kan collega's van de eigen organisatie uitnodigen via infraplannen.nl.
                </p>`
      },
      {
        question: '4. Hoe verwijder ik gebruikers?',
        answer: `<p>
                  Een key-user kan collega's van de eigen organisatie, die al toegang hebben verkregen, verwijderen via infraplannen.nl.
                </p>`
      },
    ],
  },
];

const PageFaq: React.FC = () => (
  <>
    <header className="page-header container">
      <h1>Veelgestelde vragen</h1>
      <p className="header-sub-title">Hieronder vindt u een overzicht van de veelgestelde vragen.</p>
    </header>

    <section>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <Faq data={faqData} />
          </div>
        </div>
      </div>
    </section>
  </>
);

export default PageFaq;